import axios from "../axios";

export function setupBlockedOnMobile(email, tenantName) {
    return axios.post(`mobile-signup`, {
        email,
        tenantName,
    }).then(({ data }) => data);
}

